import React, { memo, useEffect, useState } from "react";
import ButtonComponent from '../ButtonComponent.jsx';
import CustomSelectDropDown from '../CustomSelectDropDown.jsx';
import './style.scss';
import PropTypes from "prop-types";

const ChartFilter = (props) => {
  const [selectFYFilter, SetSelectFYFilter] = useState("SelectedFinacialYear");
  const [selectedFinacialYear, setSelectedFinacialYear] = useState(props.currentFY.trim());
  const handleSelectFY = (option) => {
    props.handleSelectFY(option);
    setSelectedFinacialYear(option.value);

    SetSelectFYFilter("SelectedFinacialYear");
  };
  const handleCustomFY = (option) => {
    props.handleCustomFY(option);
    SetSelectFYFilter("SelectedCustomYear");
    setSelectedFinacialYear(selectedFinacialYear);

  };
  useEffect(() => {
    SetSelectFYFilter("SelectedFinacialYear");
  }, [props.ApplicationChange]);

  return (
    <div>
      <div className="SelectCustomFilter ">
        <div></div>
        <div className="SelectFYFilter m-0">
          <CustomSelectDropDown
            value={props.getFinancialYearsData.find(
              (data) => data.value === selectedFinacialYear
            )}
            containerClassName={`${selectFYFilter === "SelectedFinacialYear" ? "activeFycolor" : ""} frmgroup validate default-input`}
            isSearchable={false}
            containerColor={selectFYFilter === "SelectedFinacialYear" ? true : false}
            containerwidth={"FYFilter"}
            placeholder={selectedFinacialYear}
            noOptionSorting={true}
            options={props.getFinancialYearsData}
            onChange={(choice) => {
              handleSelectFY(choice);
            }}
          />
          <ButtonComponent
            class={selectFYFilter === "SelectedFinacialYear" ? "CustomBtnStyle " : " CustomBtnStyle CustomBtnStyleSelect"}
            onClick={(option) => {
              handleCustomFY(option);
            }}
            text="Custom"
          />
        </div>

      </div>

    </div>
  );
};
export default memo(ChartFilter);
ChartFilter.propTypes = {
  currentFY: PropTypes.string.isRequired,
  handleSelectFY: PropTypes.func.isRequired,
  handleCustomFY: PropTypes.func.isRequired,
  getFinancialYearsData: PropTypes.array.isRequired,
  ApplicationChange: PropTypes.any,
};


